import { useCallback, useEffect, useRef, useState } from 'react';

import { useEcho } from '@laravel/echo-react';

type TypingPayload = {
  chatId: string;
  userId: number;
};

export function useTyping({ chatId, userId }: TypingPayload) {
  const [isTyping, setIsTyping] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const { channel } = useEcho('App.Chat');

  const handleTyping = useCallback(() => {
    if (!isTyping) {
      setIsTyping(true);
      channel().whisper('typing-start', { chatId, userId });
    }

    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      setIsTyping(false);
      channel().whisper('typing-stop', { chatId, userId });
    }, 3000);
  }, [isTyping, chatId, userId, channel]);

  const stopTyping = useCallback(() => {
    setIsTyping(false);
    channel().whisper('typing-stop', { chatId, userId });
  }, [isTyping, chatId, userId, channel]);

  useEffect(() => {
    return () => {
      stopTyping();
    };
  }, []);

  return { handleTyping, stopTyping };
}
